<template>
  <detail-layout>
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex w-full"
          autocomplete="off"
        >
          <div class="flex-1">

            <!-- IRPF -->
            <base-collapsible-switch-form ref="baseCollapsibleIRPF" v-model="form.irpfMain" @clearForm="clearIrpf"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex gap-4 items-center flex-1">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('tipos.tax_code.irpf') }}</h4>
                  <el-form-item v-if="form.irpfMain" prop="irpf" class="w-full absolute mt-6 pt-2" />
                </div>
              </template>
              <template slot="content">
                <div>
                  <list-layout :tableTools="false">
                    <template slot="table-core">
                      <base-table-pagination-mini
                        :total="pagination.total"
                        :currentPage="pagination.currentPage"
                        :perPage="pagination.pageSize"
                        @changeCurrentPage="changeCurrentPage"
                        @changePerPage="changePerPage"
                      ></base-table-pagination-mini>
                      <div class="flex flex-row space-x-2">
                        <base-button-responsive size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step3.add_IRPF')" @click="goTaxIRPFCreation" :loading="isGeneralLoading" />
                        <div class="flex flex-row w-100 gap-4">
                          <base-table-search @toggleFilters="toggleFilters" />
                        </div>
                      </div>
                    </template>
                    <template slot="table-tags">
                      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
                    </template>
                    <template slot="table-component">
                      <kendo-grid-component
                        v-model="form.irpf"
                        value-key="idImpuesto"
                        value-type="data-item"
                        single select-on-row-click
                        :spanish="spanish"
                        :data="data"
                        :kendo="kendo"
                        :loading="isGeneralLoading"
                        :selectedField="selectedField"
                        :update-columns="false"
                        @datastatechange="dataStateChange"
                        @selectionchange="onSelectionChange">
                      </kendo-grid-component>
                    </template>
                    <template slot="layout-extend">
                      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
                    </template>
                  </list-layout>
                </div>
              </template>
            </base-collapsible-switch-form>
            <!-- End IRPF -->

            <!-- Suplido -->
            <base-collapsible-switch-form ref="baseCollapsibleSuplido" v-model="form.suplidoMain" @clearForm="clearSuplido"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.suplido') }}</h4>
              </template>
              <template slot="content">
                <div>
                  <div class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.cuota') }}</label>
                      <el-form-item prop="cuotaSuplido">
                        <el-input
                          clearable
                          class="w-full"
                          type="number"
                          v-model="form.cuotaSuplido"
                          maxlength="200"
                          @change="fixCuotaSuplido"
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </template>
            </base-collapsible-switch-form>
            <!-- End Suplido -->

            <!-- Periodo -->
            <!-- <base-collapsible-form ref="baseCollapsiblePeriodo" v-model="form.periodoMain" @clearForm="clearPeriodo"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('invoices.invoices_issuing.periodo') }}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                    <el-form-item prop="periodoDesde">
                      <el-date-picker v-model="form.periodoDesde" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern"></el-date-picker>
                    </el-form-item>
                  </div>
                  <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                    <el-form-item prop="periodoHasta">
                      <el-date-picker v-model="form.periodoHasta" type="date" value-format="yyyy-MM-dd[T00:00:00]" 
                        :format="datePattern"></el-date-picker>
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible-form> -->
            <!-- End Periodo -->

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <slot name="layout-extend" />
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getImpuestosPag } from '@/services/configurations/getImpuestosPag'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/Step3Filter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

import _ from 'lodash'

export default {
  /* eslint-disable camelcase */
  name: 'step3-others',
  components: {
    DetailLayout,
    ListLayout,
    FilterPanel,
    KendoGridComponent,
    // NewIrpfDialog
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '3',
      vuexnamespace: 'invoicesIssuing/3',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      spanish: true,
      rules: {
        irpf: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        cuotaSuplido: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        periodoDesde: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.periodoDesde && this.form.periodoHasta) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
        periodoHasta: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.periodoDesde && !this.form.periodoHasta) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          }
        ],
      },
    }
  },
  computed: {
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      return tags
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    // Computed usada desde Step2Detail
    isValid: function () {
      return (!this.form.irpfMain || (this.form.irpf !== null && this.form.irpf !== '')) &&
      (!this.form.suplidoMain || (this.form.cuotaSuplido !== null && this.form.cuotaSuplido !== '')) &&
      (!this.form.periodoMain || ((this.form.periodoDesde !== null && this.form.periodoDesde !== '') && (this.form.periodoHasta !== null && this.form.periodoHasta !== '')))
    }
  },
  mounted () {
    // this.$refs.baseCollapsibleConfigGeneral.toggle()
    // this.$refs.baseCollapsibleIRPF.toggle()
    // this.$refs.baseCollapsibleSuplido.toggle()
    // this.$refs.baseCollapsiblePeriodo.toggle()
    this.prepareStep()
  },
  methods: {
    prepareStep: async function () {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      this.data = await this.applyFilters()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.form.irpf?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    resetForm (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.$store.dispatch(this.vuexnamespace + '/resetForm')
      }
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        idCliente: this.value || null,
        taxType: '04',
        name: data.name ? data.name.value : null,
        taxRateMin: data.taxRateMin ? data.taxRateMin.value : null,
        taxRateMax: data.taxRateMax ? data.taxRateMax.value : null,
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.Respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getImpuestosPag(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.form.irpf = ''
    },
    onSelectionChange: function () {
      this.validate(undefined, true)
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    clearIrpf: function () {
      this.form.irpf = ''
    },
    clearSuplido: function () {
      this.form.cuotaSuplido = ''
    },
    clearPeriodo: function () {
      this.form.periodoDesde = ''
      this.form.periodoHasta = ''
    },
    fixCuotaSuplido: function (value) {
      this.form.cuotaSuplido = this.round8Decimals(value)
    },
    round8Decimals: function (value) {
      var localValue = value
      if (typeof localValue !== 'number') {
        localValue = Number.parseFloat(String(localValue))
        if (Number.isNaN(localValue)) {
          return value
        }
      }
      return _.round(localValue, 8).toString()
    },
    goTaxIRPFCreation: function () {
      this.$store.dispatch('app/enterMode', 1)
      this.$router.push({ 
        name: 'masters/impuestos/details',
        params: { id: -1, idCliente: this.value }
      })
    }
  },
}
</script>

<style scoped>
  @media (width < 1800px) {
    ::v-deep .table-tools > :first-child{
      gap: 0.5rem;
      flex-direction: column;
      justify-content: center;
    }
  }

.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>

